import { ReactNode, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import LoadingScreen from './LoadingScreen';
import { personalDataStore } from 'stores/personalDataStore';

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

const ProtectedRouteComponent = ({ children, redirectTo = '/login' }: ProtectedRouteProps) => {
  const {
    isAuthenticated,
    userLoading,
    isAttemptingRestore,
    attemptRestoreSession,
    user
  } = personalDataStore;
  const [hasAttemptedRestore, setHasAttemptedRestore] = useState(false);
  
  const location = useLocation()

  console.log(location)

  useEffect(() => {
    const tryRestoreSession = async () => {
      if (!isAuthenticated && !hasAttemptedRestore && !isAttemptingRestore) {
        setHasAttemptedRestore(true);
        await attemptRestoreSession();
      }
    };

    tryRestoreSession();
  }, [isAuthenticated, hasAttemptedRestore, isAttemptingRestore, attemptRestoreSession]);

  // Показываем загрузку во время попытки восстановления или загрузки пользователя
  if (userLoading || isAttemptingRestore || (!isAuthenticated && !hasAttemptedRestore)) {
    return <LoadingScreen label="Загружаем ваши данные..." />;
  }

  // Если не аутентифицирован после попытки восстановления - редиректим
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  if (user && !user.firstName && location.pathname !== '/profile') {
    return <Navigate to={'/profile'} replace />;
  }

  return <>{children}</>;
};

export const ProtectedRoute = observer(ProtectedRouteComponent);
